import { Paginator } from '@app/classes';
import { CompanyDocument } from '@app/models/documents/company-document.model';
import { Candidate } from '@app/models/offer-letters/candidate.model';
import { OfferStatusColumn } from '@app/modules/offer-letter/services/tables/candidates/columns';
import { Table } from '@app/modules/table/classes/table.class';
import { AuthService } from '@app/services';
import {
    CandidateColumn,
    CosignerColumn,
    DateSentColumn,
    JobTitleColumn,
    OfferExpirationColumn,
    OfferSentAtColumn,
    StartDateColumn,
} from './columns';

export class OfferLetterTemplateAssignmentsTable extends Table {
    showMenuColumnOptions = true;
    links = false;

    constructor(
        protected auth: AuthService,
        private companyDocument: CompanyDocument
    ) {
        super(auth);
        this.boot();
    }

    setColumns(): void {
        this.columns = [
            new CandidateColumn(),
            new JobTitleColumn(),
            new CosignerColumn(),
            new OfferExpirationColumn(),
            new StartDateColumn(),
            new OfferStatusColumn(),
            new OfferSentAtColumn(),
        ];
    }

    setDataSource(): void {
        this.paginator = new Paginator(
            Candidate.with([
                'employee',
                'latestOfferLetter.position',
                'latestOfferLetter.cosigners',
                'latestOfferLetter.cosigners.employee',
            ]).where('latestOfferLetterSigningTemplateId', this.companyDocument.signingTemplate.id)
        );
    }
}
